try {
  require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
import { jsxs, jsx } from 'react/jsx-runtime';
import { Container } from '@design-system/container';
import { HeadingBlock } from '@design-system/heading-block';
import { Section } from '@design-system/section';
import classNames from 'classnames';
import { forwardRef } from 'react';
var PageBlock = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? 'div' : _ref$element,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 'full-width' : _ref$maxWidth,
    heading = _ref.heading,
    children = _ref.children,
    disableGutters = _ref.disableGutters,
    id = _ref.id,
    componentUid = _ref.componentUid;
  return jsxs(Section, Object.assign({
    ref: ref,
    mode: mode,
    element: element,
    className: classNames('cds-page-block', className),
    id: id,
    "data-component-uid": componentUid
  }, {
    children: [heading && jsx(Container, Object.assign({
      maxWidth: maxWidth
    }, {
      children: jsx(HeadingBlock, Object.assign({
        className: "cds-page-block__heading"
      }, heading))
    })), jsx(Container, Object.assign({
      disableGutters: disableGutters,
      className: "cds-page-block__content",
      maxWidth: maxWidth
    }, {
      children: children
    }))]
  }));
});
export { PageBlock };